import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';
import { formatMoney, getMiddleIndexValue } from '../utils/utils.js'
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import SelectField from './SelectField';
import CustomSpinner from './CustomSpinner.js';
import CustomSlider from './CustomSlider.js';
import ProductOption from './ProductOption.js';
import { WAButton } from '../components/Button.js';
import 'rc-slider/assets/index.css';
require(`../assets/${process.env.PAGE}/css/custom-slider.css`);
require(`../assets/${process.env.PAGE}/css/components/product.css`);

class Product extends Component {
    constructor(props){
        super(props);

        this.state = {
            product_options: [],
            loan_quota: null,
            max_quota_amount: null
        };

        this.selectProductOption = this.selectProductOption.bind(this);
    }

    componentWillMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/params`, config).then((response)=> {

            this.props.setDefaultValue({requested_amount: Object.keys(response.data.product)[getMiddleIndexValue(Object.keys(response.data.product))],
                                        requested_quotas: Object.keys(response.data.product[Object.keys(response.data.product)[getMiddleIndexValue(Object.keys(response.data.product))]])[0]})
            this.setState({
                loan_quota: response.data.product,
                max_quota_amount: response.data.max_quota_amount,
                product_options: response.data.prodsug
            });
        });
    }

    range(start, end, step) { 
        return [...Array(1+end-start).keys()].map(v => start+v).filter((value) => { return (value % step) === 0})
    }

    rangeToObject(list) {
        var marks={};
        list.forEach((value)=>{marks[value] = ''})
        return marks;
    }


    selectProductOption(quotas, amount) {
        this.props.dispatch(change(this.props.form, 'requested_quotas', quotas));
        this.props.dispatch(change(this.props.form, 'requested_amount', amount));
    }

    render() {
        const { handleSubmit, submitting, loan_amount_value, loan_quotas_value } = this.props;
        const exceeded_loan_amount = (this.state.max_quota_amount && this.state.loan_quota && this.state.loan_quota[loan_amount_value][loan_quotas_value] > this.state.max_quota_amount);
        const sug_products = this.state.product_options.map((product, index) => {
            let amountOption = Object.keys(product)[0];
            let quotaOption = Object.keys(product[amountOption])[0];
            return (<div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 text-center" key={index}>
                        <ProductOption  quotaOption={parseInt(quotaOption, 10)}
                                        amountOption={parseInt(amountOption, 10)}
                                        currentQuota={loan_quotas_value}
                                        currentAmount={loan_amount_value}
                                        onClick={this.selectProductOption}
                                        gaEvent="true"
                                        gaCategory="FunnelSteps"
                                        gaAction="ProductSelected"
                                        gaValue={amountOption}
                                        gaLabel="Btn-10000a-12c" />
                    </div>);
        });


        return (

             <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <div className="step_product">
                            <FormattedHTMLMessage id="app.step_product" description="Product info"/>
                        </div>
                        <WAButton phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.addProduct)} className="pvc-form">
                         {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            <div className="row">
                                {sug_products || null}
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                                    <label className="control-label"> monto </label>
                                    <div className="form-group">
                                        <p className="pd-slider-value">
                                            { this.state.loan_quota !== null &&
                                                typeof(loan_amount_value) !== 'undefined' &&
                                                formatMoney(loan_amount_value, 0, ',', '.') }
                                        </p>
                                    </div>
                                    <label className="control-label"><FormattedHTMLMessage id="app.step_product_label_quota" description="cuota"/></label>
                                    <div className={'form-group has-error-centered-message ' + (exceeded_loan_amount && 'has-error')}>
                                        <p className="pd-slider-value">
                                            {
                                                this.state.loan_quota !== null &&
                                                (typeof(this.state.loan_quota[loan_amount_value]) !== 'undefined' &&
                                                formatMoney(this.state.loan_quota[loan_amount_value][loan_quotas_value], 0, ',', '.') ||
                                                typeof(this.state.loan_quota[loan_amount_value][Object.keys(this.state.loan_quota[loan_amount_value])[0]]) !== 'undefined' &&
                                                formatMoney(this.state.loan_quota[loan_amount_value][Object.keys(this.state.loan_quota[loan_amount_value])[0]], 0, ',', '.'))
                                            }
                                        </p>
                                        <div className="help-block">
                                            { exceeded_loan_amount && (<span>{'La cuota excede lo máximo disponible para su perfil crediticio.'}</span>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
                                    <Field name="requested_amount"
                                            label="Monto"
                                            component={CustomSlider}
                                            productList={this.state.loan_quota && Object.keys(this.state.loan_quota)}
                                            initialValue={loan_amount_value}
                                        />
                                </div>
                                <div className="col-sm-offset-5 col-sm-2 col-xs-offset-4 col-xs-4 text-center">
                                    <label className="control-label">Cuotas</label>
                                    { this.state.loan_quota && (
                                        <Field
                                            name="requested_quotas"
                                            component={SelectField}
                                            options={this.state.loan_quota && Object.keys(this.state.loan_quota[loan_amount_value]).map(value => { return {id: value, name: value}})}
                                            label={'Género'}/>) 
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting || exceeded_loan_amount}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

Product.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('product')

Product = connect(
    state => {
        const loan_amount_value = selector(state, 'requested_amount')
        const loan_quotas_value = selector(state, 'requested_quotas')
        return {
            loan_amount_value,
            loan_quotas_value,
        }
    }
)(Product)

Product = TopScrolleable(Product);

Product = reduxForm({
    form: 'product', // a unique name for this form
})(Product);

Product = withAuthControl(Product);

export default Product;



/** WEBPACK FOOTER **
 ** ./src/components/Product.js
 **/